var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_326072)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_326072",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.002V0.00195312H20V14.4713C19.4352 11.9295 17.163 10.0236 14.4534 10.0236C11.3203 10.0236 8.77199 12.572 8.77199 15.7051C8.77199 16.3808 8.90077 17.0512 9.14924 17.689C8.75457 18.2026 8.65836 18.8897 8.91138 19.501C8.98855 19.6873 9.09369 19.8556 9.22076 20.002H0ZM20 20.002H18.3347C19.1586 19.1926 19.7487 18.1288 20 16.9643V20.002Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_326072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.668 3.33594H3.33464C2.4138 3.33594 1.66797 4.08177 1.66797 5.0026V15.0026C1.66797 15.9234 2.4138 16.6693 3.33464 16.6693H16.668C17.5888 16.6693 18.3346 15.9234 18.3346 15.0026V5.0026C18.3346 4.08177 17.5888 3.33594 16.668 3.33594ZM8.33464 6.66927C8.79464 6.66927 9.16797 7.04261 9.16797 7.50261C9.16797 7.96261 8.79464 8.33594 8.33464 8.33594C7.87464 8.33594 7.5013 7.96261 7.5013 7.50261C7.5013 7.04261 7.87464 6.66927 8.33464 6.66927ZM15.0013 14.1693H5.01964C4.67297 14.1693 4.47797 13.7701 4.6913 13.4968L6.7663 10.8284C6.92964 10.6184 7.24547 10.6134 7.41547 10.8184L9.16797 12.9276L11.7496 9.60094C11.918 9.38344 12.2471 9.38677 12.4121 9.60677L15.3346 13.5026C15.5405 13.7776 15.3446 14.1693 15.0013 14.1693Z",
    fill: "#757575"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6185 15.7055C18.6185 17.522 17.4511 19.256 15.8422 19.8279C15.7588 19.8574 15.6725 19.8718 15.5884 19.8718C15.277 19.8718 14.9846 19.6779 14.8748 19.3673C14.7347 18.9734 14.9407 18.5409 15.3346 18.4007C16.3429 18.0417 17.1034 16.8834 17.1034 15.7055C17.1034 14.2434 15.9141 13.0541 14.4521 13.0541C12.9901 13.0541 11.8008 14.2434 11.8008 15.7055C11.8008 16.1198 11.9098 16.5122 12.0886 16.869L12.7818 16.1759C12.9787 15.9797 13.3158 16.1191 13.3158 16.3978V18.4204C13.3158 18.8037 13.0052 19.1143 12.6212 19.1143H10.5986C10.3198 19.1143 10.1804 18.7772 10.3774 18.5803L10.9826 17.975L10.991 17.9667C10.5516 17.3061 10.2857 16.5319 10.2857 15.7055C10.2857 13.4079 12.1553 11.5391 14.4521 11.5391C16.7489 11.5391 18.6185 13.4079 18.6185 15.7055Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_326072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeImageIcon);
export default __webpack_public_path__ + "static/media/change-image-icon.445cb9d417ae6cd14e9ddb3a0eb31d17.svg";
export { ForwardRef as ReactComponent };